/**
 * Danish formatting. Numbers are grouped the way a Danish reader expects, so 1200 reads as
 * 1.200 both on screen and in the report.
 */
const LOCALE = 'da-DK';

const integer = new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 0 });
const oneDecimal = new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 1 });
const longDate = new Intl.DateTimeFormat(LOCALE, { day: 'numeric', month: 'long', year: 'numeric' });
const shortDateTime = new Intl.DateTimeFormat(LOCALE, {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatNumber(value: number | null | undefined): string {
  return value === null || value === undefined ? '–' : integer.format(value);
}

export function formatScore(value: number | null | undefined): string {
  return value === null || value === undefined ? '–' : oneDecimal.format(value);
}

export function formatDate(value: string | null | undefined): string {
  return value ? longDate.format(new Date(value)) : '–';
}

export function formatDateTime(value: string | null | undefined): string {
  return value ? shortDateTime.format(new Date(value)) : '–';
}

/** Whole days from now until the given instant, floored at zero. */
export function daysUntil(value: string | null | undefined): number {
  if (!value) {
    return 0;
  }
  const millisecondsPerDay = 86_400_000;
  const difference = new Date(value).getTime() - Date.now();
  return Math.max(0, Math.floor(difference / millisecondsPerDay));
}
